/* eslint-disable camelcase */
import React from 'react'
import { Grid, TextField } from '@material-ui/core'
import ReactInputMask from 'react-input-mask'

const FormAddressContact = ({
  form,
  handleChange = () => {},
  handleSearchCep = () => {},
}) => {
  return (
    <>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <ReactInputMask
              mask="99.999-999"
              maskChar=""
              name="client_cep"
              value={form?.client_cep}
              onChange={handleChange}
              onBlur={() => handleSearchCep(form?.client_cep)}
              required
            >
              {inputProps => (
                <TextField {...inputProps} label="CEP" fullWidth />
              )}
            </ReactInputMask>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={8}>
            <TextField
              name="client_street"
              value={form.client_street}
              onChange={handleChange}
              label="Logradouro"
              required
              fullWidth
            />
          </Grid>

          <Grid item xs={4}>
            <TextField
              name="client_number"
              value={form.client_number}
              onChange={handleChange}
              label="Número"
              required
              fullWidth
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              name="client_neighborhood"
              value={form.client_neighborhood}
              onChange={handleChange}
              label="Bairro"
              required
              fullWidth
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              name="client_complement"
              value={form.client_complement}
              onChange={handleChange}
              label="Complemento"
              fullWidth
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              name="client_city"
              value={form.client_city}
              label="Cidade"
              required
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              name="client_uf"
              value={form.client_uf}
              label="Estado"
              required
              fullWidth
              disabled
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={4}>
        <ReactInputMask
          mask="(99) 99999-9999"
          maskChar=""
          name="client_phone"
          value={form?.client_phone}
          onChange={handleChange}
        >
          {inputProps => (
            <TextField {...inputProps} label="Telefone" fullWidth />
          )}
        </ReactInputMask>
      </Grid>

      <Grid item xs={3}>
        <TextField
          name="client_email"
          value={form.client_email}
          label="E-mail"
          fullWidth
          required
          type="email"
          onChange={handleChange}
        />
      </Grid>
    </>
  )
}

export default FormAddressContact
